import { apiSlice } from "./apiSlice";

export type Database = {
    name: string,
    database: string,
    isDefault?: boolean,
}

export const databaseApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDatabaseLocations: builder.query<Database[], void>({
            query: () => 'public/database',
            providesTags: ["Databases"]
        }),
        getDatabaseVersion: builder.query({
            query: () => ({
                url: 'public/database/version',
                responseHandler: (response: any) => response.text(),
            }),
            providesTags: (result, error, { database }) => [
                { type: 'Database', id: database },
            ]
        }),
    })
});


export const {
    useGetDatabaseLocationsQuery,
    useGetDatabaseVersionQuery,
} = databaseApiSlice;